import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import { Image } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './DefaultVolume.scss'


const ProductVolumesDefaultVolume = (props) => {
  const { className, item, index, isActive, brand, onSelect, withMicrodata, testId } = props
  const { id, img, volume, volumeUnit, type, actualType, price, productGroup, inStock } = item

  const volumeClassName = cx(s.volume, {
    [s.active]: isActive,
  })

  const isMakeup = (
    productGroup === 'Makeup'
    || productGroup === 'EyeLiner'
    || productGroup === 'LipLiner'
    || productGroup === 'LipCrayon'
  )

  const isPerfumeGroup  = productGroup === 'Perfume'
  const isFullSize      = actualType === 'PerfumeBottle'

  let volumeMessage = messages.oneTimePurchase

  if (type === 'subscription') {
    volumeMessage = messages.subscription
  }
  else if (isPerfumeGroup) {
    volumeMessage = isFullSize ? messages.fullSize : messages.oneTimeShipment
  }

  return (
    <div
      key={id}
      className={cx(className, s.volumeContainer)}
      {...withMicrodata && {
        itemProp: 'offers',
        itemScope: true,
        itemType: 'http://schema.org/Offer',
      }}
    >
      <button
        className={volumeClassName}
        type="button"
        data-testid={testId}
        onClick={() => onSelect(index)}
      >
        <div className={s.volumePreview}>
          <Image
            src={img}
            alt="volume"
            h={50}
            x2
            {...withMicrodata && { itemProp: 'image' }}
          />
        </div>
        <Text className={s.text} size="14-16">
          {
            !isMakeup && (
              <span>
                {volume}&nbsp;{volumeUnit}{' '}
              </span>
            )
          }
          <Message className={s.excerpt} text={volumeMessage} />
        </Text>
        {
          withMicrodata && (
            <span style={{ display: 'none' }}>
              <span itemProp="sku">{id}</span>
              <span itemProp="priceCurrency">USD</span>
              <span itemProp="price">{price / 100}</span>
              <span itemProp="category">{brand}</span>
              <link
                itemProp="availability"
                href={`http://schema.org/${inStock ? 'InStock' : 'OutOfStock'}`}
              />
            </span>
          )
        }
      </button>
    </div>
  )
}

ProductVolumesDefaultVolume.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    volume: PropTypes.number,
    volumeUnit: PropTypes.string,
    type: PropTypes.string,
    actualType: PropTypes.string,
    price: PropTypes.number,
    productGroup: PropTypes.string,
    inStock: PropTypes.bool,
  }),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  brand: PropTypes.string,
  onSelect: PropTypes.func,
  withMicrodata: PropTypes.bool,
  testId: PropTypes.string,
}


export default ProductVolumesDefaultVolume
